import { useState } from "react";
import { Form } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import "bulma/css/bulma.css";
import "../../../../../../../../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import ToastError from "../../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../../NotificationToast/ToastSuccess";
import { APISD } from "../../../../../../../../config/apisd";

const FIELDS = [
  { name: "bobot_asts", label: "Bobot ASTS" },
  { name: "bobot_asas", label: "Bobot ASAS" },
  { name: "bobot_sumatif_harian", label: "Bobot Sumatif Harian" },
  { name: "bobot_sumatif_akhir", label: "Bobot Sumatif Akhir" },
];

const INITIAL_FORM = {
  bobot_asts: "",
  bobot_asas: "",
  bobot_sumatif_harian: "",
  bobot_sumatif_akhir: "",
};

const getAdminId = () => {
  const storedId = localStorage.getItem("id_admin");
  if (!storedId) return null;

  try {
    return JSON.parse(storedId);
  } catch {
    return storedId;
  }
};

export default function ModalBobotAdd(props) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form, setForm] = useState(INITIAL_FORM);
  const [selectedSemesters, setSelectedSemesters] = useState(() =>
    (props.semesterOptions || []).map((semester) => String(semester.id))
  );

  const handleChange = ({ target: { name, value } }) => {
    if (value.includes(",")) return;
    setForm((previous) => ({ ...previous, [name]: value }));
  };

  const preventComma = (event) => {
    if (event.key === ",") event.preventDefault();
  };

  const preventCommaPaste = (event) => {
    if (event.clipboardData.getData("text").includes(",")) {
      event.preventDefault();
      ToastError.fire({ icon: "error", title: "Gunakan titik (.) untuk angka desimal" });
    }
  };

  const handleSemesterChange = (semesterId) => {
    const id = String(semesterId);
    setSelectedSemesters((previous) =>
      previous.includes(id)
        ? previous.filter((item) => item !== id)
        : [...previous, id]
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const invalid = FIELDS.some(
      ({ name }) => form[name] === "" || Number(form[name]) < 0 || Number(form[name]) > 100
    );

    if (selectedSemesters.length === 0) {
      ToastError.fire({ icon: "error", title: "Pilih minimal satu semester" });
      return;
    }

    if (invalid) {
      ToastError.fire({ icon: "error", title: "Semua bobot wajib diisi dengan nilai 0-100 menggunakan titik untuk desimal" });
      return;
    }

    setIsSubmitting(true);
    try {
      const token = localStorage.getItem("token");
      const createBy = getAdminId();
      await APISD.post("/api/standar-calculation/store", {
        ysb_academic_year_id: props.filterData.ysb_academic_year_id,
        ysb_semester_id: selectedSemesters,
        ysb_branch_id: props.filterData.ysb_branch_id,
        ysb_school_id: props.filterData.ysb_school_id,
        bobot_asts: Number(form.bobot_asts),
        bobot_asas: Number(form.bobot_asas),
        bobot_sumatif_harian: Number(form.bobot_sumatif_harian),
        bobot_sumatif_akhir: Number(form.bobot_sumatif_akhir),
        create_by: createBy,
      }, { headers: { Authorization: `${token}`, "Content-Type": "application/json" } });
      await props.GetResponseData();
      ToastSuccess.fire({ icon: "success", title: "Semua data bobot berhasil ditambahkan" });
      props.onHide();
    } catch (error) {
      ToastError.fire({ icon: "error", title: error?.response?.data?.message || "Gagal menyimpan data bobot" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal {...props} centered backdrop="static" keyboard={false} dialogClassName="sims-modal-dialog" contentClassName="sims-modal-content" aria-labelledby="modal-tambah-bobot">
      <div className="sims-modal-header">
        <div>
          <h5 id="modal-tambah-bobot" className="sims-modal-title">Tambah Bobot</h5>
         
        </div>
        <button type="button" className="sims-modal-close" onClick={props.onHide} aria-label="Tutup modal"><FontAwesomeIcon icon={faXmark} /></button>
      </div>
      <Form onSubmit={handleSubmit}>
        <div className="sims-modal-body">
          <div className="bobot-filter-info">
            <div className="bobot-filter-info-item">
              <span className="bobot-filter-info-label">Tahun Ajaran</span>
              <span className="bobot-filter-info-value">{props.filterLabels?.academicYear || "-"}</span>
            </div>
            <div className="bobot-filter-info-item">
              <span className="bobot-filter-info-label">Cabang</span>
              <span className="bobot-filter-info-value">{props.filterLabels?.branch || "-"}</span>
            </div>
            <div className="bobot-filter-info-item">
              <span className="bobot-filter-info-label">Sekolah</span>
              <span className="bobot-filter-info-value">{props.filterLabels?.school || "-"}</span>
            </div>
          </div>

          <div className="sims-form-group">
            <label className="sims-form-label">Pilih Semester <span>*</span></label>
            <div className="bobot-semester-options">
              {(props.semesterOptions || []).map((semester) => {
                const semesterId = String(semester.id);
                return (
                  <label className="bobot-semester-option" key={semesterId}>
                    <input
                      type="checkbox"
                      checked={selectedSemesters.includes(semesterId)}
                      onChange={() => handleSemesterChange(semesterId)}
                    />
                    Semester {semester.semester}
                  </label>
                );
              })}
            </div>
          </div>

          <div className="bobot-fields-grid">
            {FIELDS.map(({ name, label }) => (
              <div className="sims-form-group" key={name}>
                <label className="sims-form-label" htmlFor={`${name}_add`}>{label} <span>*</span></label>
                <input
                  id={`${name}_add`}
                  className="sims-form-input"
                  required
                  type="number"
                  inputMode="decimal"
                  name={name}
                  min="0"
                  max="100"
                  step="any"
                  onKeyDown={preventComma}
                  onPaste={preventCommaPaste}
                  onChange={handleChange}
                  value={form[name]}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="sims-modal-footer">
          <button type="button" className="sims-modal-cancel" onClick={props.onHide} disabled={isSubmitting}>Batal</button>
          <button type="submit" className="sims-modal-submit" disabled={isSubmitting}><FontAwesomeIcon icon={faFloppyDisk} /> {isSubmitting ? "Menyimpan..." : "Simpan Semua"}</button>
        </div>
      </Form>
    </Modal>
  );
}
